import { FC } from 'react';

import { SystemPageType } from '@ravago/shared/page-data/enums/system-page-type';
import { Box } from '@ravago/shared/radiance/components/box/components/Box/Box';
import { IconButton } from '@ravago/shared/radiance/components/button/components/IconButton/IconButton';
import { Table } from '@ravago/shared/radiance/components/table/components/Table/Table';
import { TableBody } from '@ravago/shared/radiance/components/table/components/TableBody/TableBody';
import { TableCell } from '@ravago/shared/radiance/components/table/components/TableCell/TableCell';
import { TableRow } from '@ravago/shared/radiance/components/table/components/TableRow/TableRow';
import { useTranslations } from '@ravago/shared/translations/client';

import { SystemPageLink } from '../../../content/system-page-link/system-page-link';

interface Props {
   locale: string;
   shipmentIds: number[];
   baseRoute?: string;
}

export const ShipmentsInfo: FC<Props> = ({ locale, shipmentIds, baseRoute }) => {
   const translate = useTranslations();

   return (
      <Table rowDividers={false} border rounded stroked="horizontal">
         <TableBody>
            {shipmentIds.map((shipmentId) => (
               <TableRow key={shipmentId}>
                  <TableCell>
                     {translate('page-consumer.order-line-flyout.shipment')} {shipmentId}
                  </TableCell>
                  <TableCell>
                     <SystemPageLink baseRoute={baseRoute} locale={locale} type={SystemPageType.SHIPMENT} slug={shipmentId.toString()}>
                        <Box justify="end">
                           <IconButton icon="arrow-right" />
                        </Box>
                     </SystemPageLink>
                  </TableCell>
               </TableRow>
            ))}
         </TableBody>
      </Table>
   );
};
